"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ably = require("ably");

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("../shared/constants");

var _logger = _interopRequireDefault(require("../utils/logger"));

var _monitoringService = _interopRequireDefault(require("../services/monitoringService"));

var _ablyConstants = require("./ablyConstants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MESSAGE_EVENT_TYPE = 'message'; // For backwards compatibility with the Ably adapter, we need to prefix our channel names.

var CHANNEL_NAME_PREFIX = 'pn:';
var CHANNEL_PREFIX_REGEX = new RegExp('^' + CHANNEL_NAME_PREFIX);

var AblyProvider = /*#__PURE__*/function () {
  function AblyProvider(config, userId, connectionChangeCallback) {
    var _this = this;

    (0, _classCallCheck2.default)(this, AblyProvider);
    (0, _defineProperty2.default)(this, "presenceEventType", void 0);
    (0, _defineProperty2.default)(this, "config", void 0);
    (0, _defineProperty2.default)(this, "userId", void 0);
    (0, _defineProperty2.default)(this, "roleFilter", void 0);
    (0, _defineProperty2.default)(this, "ably", void 0);
    (0, _defineProperty2.default)(this, "ablyRest", void 0);
    (0, _defineProperty2.default)(this, "connectionPromise", void 0);
    (0, _defineProperty2.default)(this, "onAblyMessage", void 0);
    (0, _defineProperty2.default)(this, "originalHandler", void 0);
    (0, _defineProperty2.default)(this, "timeOffsetPromise", void 0);
    this.config = config;
    this.userId = userId;
    this.presenceEventType = _constants.PRESENCE_EVENT_TYPE;
    this.roleFilter = undefined;

    if (!config || !config.key) {
      throw new Error('Cannot initialize Ably. Config must contain an API key.');
    }

    var ablyConfig = {
      key: config.key,
      clientId: userId,
      channelRetryTimeout: 25000,
      // 25s
      environment: 'amplify'
    };
    this.ably = new _ably.Realtime(ablyConfig);
    this.ablyRest = new _ably.Rest(ablyConfig);
    var removeConnectionListeners;
    this.connectionPromise = new Promise(function (resolve, reject) {
      _this.ably.connection.on(_ablyConstants.CONNECTION_STATUSES.CONNECTED, resolve);

      _this.ably.connection.on(_ablyConstants.CONNECTION_STATUSES.FAILED, reject);

      removeConnectionListeners = function removeConnectionListeners() {
        _this.ably.connection.off(_ablyConstants.CONNECTION_STATUSES.CONNECTED, resolve);

        _this.ably.connection.off(_ablyConstants.CONNECTION_STATUSES.FAILED, reject);
      };
    }).catch(function () {
      // Ably will not auto-recover from a failed connection; throw an error
      throw new Error("Cannot connect to Ably; connection status: ".concat(_ablyConstants.CONNECTION_STATUSES.FAILED));
    }).finally(removeConnectionListeners);
    this.handleConnectionChanges(connectionChangeCallback);
    /**
     * Retrieve clock offset from the system to Ably server source of truth in ms
     * This allows reliable timestamp comparisons across devices
     */

    this.timeOffsetPromise = new Promise(function (resolve) {
      _this.ablyRest.time(function (err, serverTime) {
        if (err) {
          _logger.default.error('Error retrieving Ably time offset ', err);

          resolve(0);
        } else {
          resolve(Date.now() - serverTime);
        }
      });
    });
  }
  /**
   * Initialize Ably message listener.
   */


  (0, _createClass2.default)(AblyProvider, [{
    key: "init",
    value: function init(onMessage) {
      var _this2 = this;

      this.onAblyMessage = /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(eventType, message, channelName) {
          var _this2$parseMessage, name, data, clientId, payload, recipient, action, _clientId, connectedClients, clientConnections, _payload;

          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(eventType === MESSAGE_EVENT_TYPE)) {
                    _context.next = 6;
                    break;
                  }

                  _this2$parseMessage = _this2.parseMessage(message), name = _this2$parseMessage.name, data = _this2$parseMessage.data, clientId = _this2$parseMessage.clientId;
                  payload = data.payload, recipient = data.recipient;

                  if (!_this2.roleFilter || recipient === _constants.ROLES.ALL || recipient === _this2.roleFilter) {
                    onMessage(name, _this2.removeChannelNamePrefix(channelName), payload, clientId);
                  }

                  _context.next = 17;
                  break;

                case 6:
                  if (!(eventType === _constants.PRESENCE_EVENT_TYPE)) {
                    _context.next = 17;
                    break;
                  }

                  action = message.action, _clientId = message.clientId; // handle extra leave events if client has multiple connections

                  if (!(action === _ablyConstants.LEAVE)) {
                    _context.next = 16;
                    break;
                  }

                  _context.next = 11;
                  return _this2.getChannelPresence(channelName);

                case 11:
                  connectedClients = _context.sent;
                  clientConnections = connectedClients.filter(function (client) {
                    return client.clientId === _clientId;
                  });

                  if (!(clientConnections.length > 0)) {
                    _context.next = 16;
                    break;
                  }

                  _logger.default.warn("Ignoring extra leave event from ".concat(_clientId));

                  return _context.abrupt("return");

                case 16:
                  if (_ablyConstants.ABLY_PRESENCE_ACTIONS_MAP[action]) {
                    _payload = {
                      action: _ablyConstants.ABLY_PRESENCE_ACTIONS_MAP[action]
                    };
                    onMessage(_this2.presenceEventType, _this2.removeChannelNamePrefix(channelName), _payload, _clientId);
                  }

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();
    }
    /**
     * Set a filter to prevent the client from listening for messages that are not relevant to their user role.
     */

  }, {
    key: "setFilter",
    value: function setFilter(userRole) {
      this.roleFilter = userRole;
    }
    /**
     * Publish a message to an Ably channel.
     */

  }, {
    key: "publish",
    value: function () {
      var _publish = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(channelName, eventType, payload, recipient) {
        var channel;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.connectionPromise;

              case 2:
                channel = this.ably.channels.get(this.getPrefixedChannelName(channelName));
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  // eventType is included in the payload for backwards compatibility with the Ably adapter
                  var wrappedPayload = {
                    payload: payload,
                    recipient: recipient,
                    eventType: eventType
                  };
                  channel.publish(eventType, wrappedPayload, function (error) {
                    if (error) {
                      _monitoringService.default.reportError("Failed publish. ".concat(error.code, ": ").concat(error.message), channelName);

                      reject(error);
                    }

                    resolve();
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function publish(_x4, _x5, _x6, _x7) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
    /**
     * Subscribe to a list of Ably channels.
     */

  }, {
    key: "subscribeToChannels",
    value: function () {
      var _subscribeToChannels = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(channelNames, withPresence) {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.connectionPromise;

              case 2:
                channelNames.forEach(function (channelName) {
                  var channelOpts = {
                    modes: (0, _toConsumableArray2.default)(_ablyConstants.ABLY_DEFAULT_CHANNEL_MODES)
                  };

                  if (withPresence) {
                    channelOpts.modes.push(_ablyConstants.ABLY_PRESENCE_SUBSCRIBE_CHANNEL_MODE);
                  }

                  var channel = _this3.ably.channels.get(_this3.getPrefixedChannelName(channelName));

                  channel.setOptions(channelOpts);
                  channel.attach(function (error) {
                    if (error) {
                      _monitoringService.default.reportError("Failed to attach to channel. ".concat(error.code, ": ").concat(error.message), channelName);
                    }
                  });
                  channel.presence.enter();
                  channel.subscribe(function (message) {
                    _this3.onAblyMessage(MESSAGE_EVENT_TYPE, message, channelName);
                  });

                  if (withPresence) {
                    channel.presence.subscribe(function (message) {
                      _this3.onAblyMessage(_constants.PRESENCE_EVENT_TYPE, message, channelName);
                    });
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function subscribeToChannels(_x8, _x9) {
        return _subscribeToChannels.apply(this, arguments);
      }

      return subscribeToChannels;
    }()
    /**
     * Unsubscribe from a list of Ably channels.
     */

  }, {
    key: "unsubscribeFromChannels",
    value: function () {
      var _unsubscribeFromChannels = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(channelNames) {
        var _this4 = this;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.connectionPromise;

              case 2:
                channelNames.forEach(function (channelName) {
                  var channel = _this4.ably.channels.get(_this4.getPrefixedChannelName(channelName));

                  channel.unsubscribe();
                  channel.presence.leave();
                  channel.presence.unsubscribe();
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function unsubscribeFromChannels(_x10) {
        return _unsubscribeFromChannels.apply(this, arguments);
      }

      return unsubscribeFromChannels;
    }()
    /**
     *  Close connection with Ably.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.ably.close();
      this.ably = null;
    }
    /**
     * Get list of user ids in the channel.
     */

  }, {
    key: "getCurrentSubscribers",
    value: function () {
      var _getCurrentSubscribers = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(channelName) {
        var connectedClients;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getChannelPresence(channelName);

              case 2:
                connectedClients = _context5.sent;
                return _context5.abrupt("return", _lodash.default.uniq(connectedClients.map(function (_ref2) {
                  var clientId = _ref2.clientId;
                  return clientId;
                })));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCurrentSubscribers(_x11) {
        return _getCurrentSubscribers.apply(this, arguments);
      }

      return getCurrentSubscribers;
    }()
  }, {
    key: "getTimeMs",
    value: function () {
      var _getTimeMs = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var timeOffset;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.timeOffsetPromise;

              case 2:
                timeOffset = _context6.sent;
                return _context6.abrupt("return", Date.now() - timeOffset);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getTimeMs() {
        return _getTimeMs.apply(this, arguments);
      }

      return getTimeMs;
    }()
    /**
     * Get the list of clients connected to the channel.
     */

  }, {
    key: "getChannelPresence",
    value: function () {
      var _getChannelPresence = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(channelName) {
        var channel;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.connectionPromise;

              case 2:
                channel = this.ably.channels.get(this.getPrefixedChannelName(channelName));
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  return channel.presence.get(function (error, members) {
                    if (error) {
                      _monitoringService.default.reportError("Error retrieving subscribers. ".concat(error.code, ": ").concat(error.message), channelName);

                      reject(error);
                    }

                    resolve(members);
                  });
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getChannelPresence(_x12) {
        return _getChannelPresence.apply(this, arguments);
      }

      return getChannelPresence;
    }()
    /**
     * For backwards compatibility with the Ably adapter, parse a message into the expected format for this provider if
     * it has been published in the format used by the adapter.
     */

  }, {
    key: "parseMessage",
    value: function parseMessage(message) {
      if (!message.name) {
        return {
          clientId: message.clientId,
          name: message.data.eventType,
          data: {
            payload: message.data.payload,
            recipient: _lodash.default.get(message, 'extra.headers.recipient', _constants.ROLES.ALL)
          }
        };
      } else {
        return message;
      }
    }
  }, {
    key: "getPrefixedChannelName",
    value: function getPrefixedChannelName(channelName) {
      if (this.config.usePrefixedChannelNames && !channelName.match(CHANNEL_PREFIX_REGEX)) {
        return CHANNEL_NAME_PREFIX + channelName;
      }

      return channelName;
    }
  }, {
    key: "removeChannelNamePrefix",
    value: function removeChannelNamePrefix(channelName) {
      if (this.config.usePrefixedChannelNames && channelName.match(CHANNEL_PREFIX_REGEX)) {
        return channelName.replace(CHANNEL_PREFIX_REGEX, '');
      }

      return channelName;
    }
  }, {
    key: "handleConnectionChanges",
    value: function handleConnectionChanges(connectionChangeCallback) {
      this.ably.connection.on(_ablyConstants.CONNECTION_STATUSES.CONNECTED, function () {
        _monitoringService.default.reportAction("Connected to Ably; connection status: ".concat(_ablyConstants.CONNECTION_STATUSES.CONNECTED));

        if (connectionChangeCallback) {
          connectionChangeCallback(true, _ablyConstants.CONNECTION_STATUSES.CONNECTED);
        }
      });
      this.ably.connection.on(_ablyConstants.CONNECTION_STATUSES.DISCONNECTED, function () {
        _monitoringService.default.reportError("Lost connection to Ably; connection status: ".concat(_ablyConstants.CONNECTION_STATUSES.DISCONNECTED));

        if (connectionChangeCallback) {
          connectionChangeCallback(false, _ablyConstants.CONNECTION_STATUSES.DISCONNECTED);
        }
      });
      this.ably.connection.on(_ablyConstants.CONNECTION_STATUSES.FAILED, function () {
        _monitoringService.default.reportError("Lost connection to Ably; connection status: ".concat(_ablyConstants.CONNECTION_STATUSES.FAILED));

        if (connectionChangeCallback) {
          connectionChangeCallback(false, _ablyConstants.CONNECTION_STATUSES.FAILED);
        }
      });
    } // DEPRECATED: included only to support legacy code from the curriculum app.
    // Not intended for future use.

    /* eslint-disable @typescript-eslint/no-explicit-any */

  }, {
    key: "subscribeAndListen",
    value: function subscribeAndListen(channelNames, listenerObj, withPresence) {
      var _this5 = this;

      this.subscribeToChannels(channelNames, withPresence);
      this.originalHandler = this.onAblyMessage;

      this.onAblyMessage = function (eventType, message, channelName) {
        _this5.originalHandler(eventType, message, channelName);

        if (eventType === MESSAGE_EVENT_TYPE) {
          listenerObj.message({
            message: _objectSpread({}, message.data)
          });
        }
      };
    } // DEPRECATED: included only to support legacy code from the curriculum app.
    // Not intended for future use.

  }, {
    key: "stopListeningAndUnsubscribe",
    value: function stopListeningAndUnsubscribe(channelNames) {
      this.unsubscribeFromChannels(channelNames);

      if (this.originalHandler) {
        this.onAblyMessage = this.originalHandler;
      }
    }
  }]);
  return AblyProvider;
}();

var _default = AblyProvider;
exports.default = _default;
//# sourceMappingURL=AblyProvider.js.map